/**
 * Haalt de gekoppelde deelnemers uit een reeks EventResults-documenten.
 *
 * Deelnemers staan in `Participants` op de outputregel zelf. Documenten van
 * vóór 2026-08-25 hebben dat veld niet; die leveren simpelweg niets op.
 *
 * AI-CONTEXT: See docs/handleiding/data-verzamelen.md (deelnemers per output)
 *
 * @param {Array<{Participants?: string[]}>} results - EventResults-documenten
 * @returns {string[]} Unieke deelnemer-ID's, in de volgorde waarin ze voorkomen
 */
const participantsFromResults = (results) => {
    const seen = new Set()

    for (const result of results || []) {
        const participants = Array.isArray(result?.Participants) ? result.Participants : []
        for (const personaId of participants) {
            if (personaId) seen.add(personaId)
        }
    }

    return Array.from(seen)
}

export default participantsFromResults
